import "./styles.scss";

var image = document.getElementsByClassName('fondito');



new simpleParallax(image);